[<template>
  <span
    :class="classes"
    >
    {{ abs }}%

    <PercentArrow class="percent__arrow" />
  </span>
</template>]

<script>
  import PercentArrow from '@/assets/percent-arrow.svg';

  export default {
    components: {
      PercentArrow,
    },

    props: {
      value: {
        type: Number,
        required: true,
      },
    },

    computed: {
      abs () {
        return Math.abs(this.value);
      },

      classes () {
        return [
          'percent',
          'percent--' + (this.value >= 0 ? 'high' : 'low'),
        ];
      },
    },
  };
</script>

<style lang="scss">
  .percent {
    font-size: 14px;
    margin-top: -1px;
    margin-right: 3px;
    letter-spacing: 0.3px;

    &--high {
      color: #60c101;
    }

    &--low {
      color: #ff011f;

      .percent__arrow {
        transform: rotate(180deg);
      }
    }
  }
</style>
